// The standard public-page nav links — Download · MCP · Pricing.
// Mounted in the TopBar `links` slot of EVERY pre-login page so navigation
// is identical no matter where a logged-out visitor lands (Landing, Pricing,
// the docs, Terms/Privacy, the auth page). One source of truth so pages
// can't drift back into "some have the links, some don't".
//
// 2026-07-21:下载页对登录与否**都显示** —— 创作在桌面端,所以「去哪创作」
// 对新访客和老用户是同一个答案。以前那条按登录态才出现的「我的项目」没有了。
//
// ★ 2026-07-25 六项砍到三项 —— 顶栏里**不放工作流**:
//   · 「工作流」= 首页本身(点 logo 就回去),顶栏再挂一条 = 同一个去处两个入口;
//   · 「自动加字幕」= 网格里的**一张卡** —— 顶栏给某一个工作流开后门的话,以后
//     每上线一个工作流顶栏就长一项,那张网格就白做了;
//   · 「进阶文档」退到页脚(开发者材料,不是主导航)。
//   剩下三项都**不是工作流**:去哪创作 · 怎么接 agent · 多少钱。

import { Link } from 'react-router-dom';
import { useT } from '../lib/i18n';

// ★ 2026-10-15 用户:「先把这个网站变得极其简单」—— 顶栏只剩「网页版」一项。
//   下载桌面端(桌面版已放弃,Mac 包已下线)、Agent(/mcp)、定价都退到页脚或撤掉;它们的路由还在。
export function PublicNavLinks() {
  const t = useT();
  return <Link to="/studio">{t('nav.webstudio')}</Link>;
}
